import React from 'react';
import './CustomersLove.scss';
import IconArrowRight from 'venuescanner-js/react/components/Objects/Icons/IconArrowRight';
import { ReviewIoWidget } from 'venuescanner-js/react/components/Inbox/components/Enquiry/EnquiryInfo/ReviewIoWidget';
import IconLogo from 'venuescanner-js/react/components/Objects/Icons/IconLogo';

export const CustomersLove = ({ venue }) => {
  const onClick = () => {
    window.location.assign(
      'https://www.reviews.co.uk/company-reviews/store/www.venuescanner.com',
    );
  };
  return (
    <div className='customers-love'>
      <div className='customers-love__container' onClick={onClick}>
        <div className='customers-love__logo'>
          <span>Customers love</span>
          <div aria-labelledby='logo-label'>
            <span id='logo-label' hidden>
              VenueScanner
            </span>
            <IconLogo aria-hidden={true} width='120px' height='20px' />
          </div>
        </div>
        <ReviewIoWidget />
      </div>
      <div className='customers-love__arrow'>
        <IconArrowRight onClick={onClick} />
      </div>
    </div>
  );
};
